var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-graph"},[(_vm.isReady)?_c('div',{staticClass:"ui-graph__content"},[_c('apexchart',{attrs:{"width":"100%","height":"100%","type":_vm.type,"options":_vm.options,"series":_vm.series}})],1):_c('div',{staticClass:"ui-graph__loader"},[_c('ui-loader',{attrs:{"fixed":50,"centered":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }